// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"84b66af4","59":"20a6cf7e","99":"5bbd8857","385":"22fc59e7","529":"cde38d2e","663":"63ef9578","754":"b0cc15ef","898":"ef0de0bd","914":"1253146d","946":"fe598f32"}[chunkId] + ".chunk.js";
};